import React from "react";
import PropTypes from "prop-types";

export function ToastContainer({ children }) {
  return (
    <div className='toast-container-web-sdk' data-testid='toast-container'>
      {children}
    </div>
  );
}

export function ToastCloseButton({ onClick, settings }) {
  return (
    <button
      type='button'
      onClick={onClick}
      aria-label={settings.translations.close_this_message}
    >
      <span>X</span>
    </button>
  );
}

export function ToastBody({ variant, children }) {
  return (
    <div className={variant || "error"} role='alert'>
      {children}
    </div>
  );
}

ToastCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  settings: PropTypes.objectOf(PropTypes.object)
};

ToastContainer.propTypes = {
  children: PropTypes.node.isRequired
};

ToastBody.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.node.isRequired
};
